import React from "react";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import ForgetPasswordForm from "../../components/auth/ForgetPasswordForm";

const ForgetPassword = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="text-center mt-4 flex flex-col gap-8">
        <div className="flex flex-col gap-5">
          <PageTitle
            title={
              Auth?.forget_password?.forget_password_title ||
              "Update your password"
            }
          />
        </div>

        <ForgetPasswordForm />
      </div>
    </AuthLayout>
  );
};

export default ForgetPassword;
